"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Close = _interopRequireDefault(require("@mui/icons-material/Close"));
var _Search = _interopRequireDefault(require("@mui/icons-material/Search"));
var _material = require("@mui/material");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var SearchField = function SearchField(_ref) {
  var searchText = _ref.searchText,
    setSearchText = _ref.setSearchText,
    placeholder = _ref.placeholder;
  var handleKeyDown = function handleKeyDown(e) {
    // Prevent certain keys from being handled by the Menu
    if (e.key === "ArrowUp" || e.key === "ArrowDown" || e.key === "Enter" || e.key === "s" || e.key === "S") {
      e.stopPropagation();
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_material.TextField, {
    variant: "outlined",
    size: "small",
    value: searchText,
    onChange: function onChange(e) {
      return setSearchText(e.target.value);
    },
    onKeyDown: handleKeyDown,
    placeholder: placeholder || "Search",
    fullWidth: true,
    slotProps: {
      input: {
        startAdornment: /*#__PURE__*/_react["default"].createElement(_material.InputAdornment, {
          position: "start"
        }, /*#__PURE__*/_react["default"].createElement(_Search["default"], {
          sx: {
            color: function color(theme) {
              return theme.palette.action.disabled;
            }
          }
        })),
        endAdornment: searchText && /*#__PURE__*/_react["default"].createElement(_material.InputAdornment, {
          position: "end"
        }, /*#__PURE__*/_react["default"].createElement(_material.IconButton, {
          onClick: function onClick() {
            return setSearchText("");
          }
        }, /*#__PURE__*/_react["default"].createElement(_Close["default"], null)))
      }
    }
  });
};
var _default = exports["default"] = SearchField;